import apis from './apis'
import blog from './blog'
import careers from './careers'
import companies from './companies'
import finance from './finance'
import financial from './financial'
import industrySectorCategories from './industry-sector-categories'
import keysList from './keys-list'
import translatables from './translatables'
import languagesLocations from './languages-locations'
import listProjects from './list-projects'
import marketing from './marketing'
import mgCompanies from './mg-companies'
import networkSystem from './network-systems'
import partners from './partners'
import partnersCategories from './partners-categories'
import pressMedia from './press-media'
import settings from './settings'
import appThemes from './themes'
import users from './users'
import notificationTemplates from './notification-templates'
import wall from './wall'
import gamification from './gamification'
import mundoGamerCity from './mundo-gamer-city'
import polls from './polls'
import contentBriefs from './content-briefs'
import mailHub from './mail-hub'
import mailSendingAccounts from './mail-sending-accounts'
import bots from './bots'
import subscriptions from './subscriptions'
import accountClosures from './account-closures'
import supportTickets from './support-tickets'
import deletionRequests from './deletion-requests'

const network = [
	{
		path: '/network/my-day',
		name: 'network-my-day',
		component: () => import('@/views/dashboards/network/MyDay.vue'),
		meta: { layout: 'content', module: 'MGN,network-systems' },
	},
	{
		path: '/network/dashboard',
		name: 'network-dashboard',
		component: () => import('@/views/dashboards/crm/Crm.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,network-systems',
		},
	},
	{
		path: '/network/team-tasks',
		name: 'network-team-tasks',
		component: () => import('@/views/dashboards/network/TeamTasks.vue'),
		meta: { layout: 'content', module: 'MGN,network-systems' },
	},
	{
		path: '/network/messages',
		name: 'network-messages-list',
		component: () => import('@/views/messages/Messages.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,messages',
		},
	},
	{
		path: '/network/newsletter',
		name: 'network-newsletter-list',
		component: () => import('@/views/newsletters/Newsletter.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,newsletter',
		},
	},
	{
		path: '/network/notification',
		name: 'network-notification-list',
		component: () => import('@/views/notifications/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,notifications',
		},
	},
	...blog,
	...apis,
	...marketing,
	...mgCompanies,
	...companies,
	...careers,
	...industrySectorCategories,
	...listProjects,
	...keysList,
	...translatables,
	...partners,
	...partnersCategories,
	...networkSystem,
	...languagesLocations,
	...users,
	...accountClosures,
	...deletionRequests,
	...finance,
	...financial,
	...pressMedia,
	...appThemes,
	...settings,
	...notificationTemplates,
	...wall,
	...gamification,
	...mundoGamerCity,
	...polls,
	...contentBriefs,
	...mailHub,
	...mailSendingAccounts,
	...bots,
	...subscriptions,
	...supportTickets,
	{
		path: '/network/email-logs',
		name: 'network-email-logs-list',
		component: () => import('@/views/network/email-logs/list.vue'),
		meta: { layout: 'content', module: 'MGN,email-logs' },
	},
	{
		// Sits beside the email logs rather than under a dashboard: the logs
		// answer "which message", this answers "can we still send at all".
		path: '/network/ses-health',
		name: 'network-ses-health',
		component: () => import('@/views/network/ses-health/SesHealth.vue'),
		// Same gate as the endpoint (role:MGN,admin), so the route and the API
		// cannot disagree about who gets in.
		meta: { layout: 'content', module: 'MGN,admin' },
	},
	{
		path: '/network/conversion-logs',
		name: 'network-conversion-logs-list',
		component: () => import('@/views/network/conversion-logs/list.vue'),
		meta: { layout: 'content', module: 'MGN,conversion-logs' },
	},
	{
		path: '/network/webhook-channels',
		name: 'network-webhook-channels',
		component: () => import('@/views/network/webhookChannels/index.vue'),
		meta: { layout: 'content', module: 'MGN,webhook-channels' },
	},
	{
		path: '/network/broadcast',
		name: 'network-broadcast',
		component: () => import('@/views/network/broadcast/index.vue'),
		meta: { layout: 'content', module: 'MGN,broadcast' },
	},
	{
		path: '/network/creator-outreach',
		name: 'network-creator-outreach',
		component: () => import('@/views/network/creator-outreach/index.vue'),
		meta: { layout: 'content', module: 'MGN,admin' },
	},
	{
		path: '/network/community/feed-config',
		name: 'community-feed-config',
		component: () => import('@/views/network/community/FeedConfig.vue'),
		meta: { layout: 'content', module: 'MGC,community' },
	},
	{
		path: '/network/ai/status',
		name: 'network-ai-status',
		component: () => import('@/views/network/ai/status.vue'),
		meta: { layout: 'content', module: 'MGN,admin' },
	},
	{
		path: '/network/ai/models',
		name: 'network-ai-models',
		component: () => import('@/views/network/ai/models.vue'),
		meta: { layout: 'content', module: 'MGN,admin' },
	},
	{
		path: '/network/live-analytics',
		name: 'network-live-analytics',
		component: () => import('@/views/network/live-analytics/LiveAnalytics.vue'),
		meta: { layout: 'blank', module: 'MGN,network-systems' },
	},
	{
		path: '/network/deploy-center',
		name: 'deploy-center',
		component: () => import('@/views/network/deploy-center/DeployCenter.vue'),
		meta: { layout: 'content', module: 'MGN,admin' },
	},
	{
		// Cross-vertical read-only aggregation (agency campaign orders,
		// showcase submissions, community review requests, plus this queue's
		// own fulfillment_tasks) — lives outside /network/* on purpose, same
		// reasoning as deploy-center/ses-health above: it isn't a "network"
		// resource, it's staff tooling gated the same way (role:MGN,admin).
		path: '/operations/fulfillment-queue',
		name: 'operations-fulfillment-queue-list',
		component: () => import('@/views/operations/fulfillment-queue/list.vue'),
		meta: { layout: 'content', module: 'MGN,admin' },
	},
]

export default network
